import axiosInstance from "../Interceptor";

export const getCustomerCollectioneApi = (payload) => {
  // console.log(payload);

  return axiosInstance
    .get(`inventory-service/api/v1/${payload}/`)

    .then((response) => {
      //  console.log(response);
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error;
    });
};
